import _ from "lodash";
import { getdataAndDecodeStoreData } from "./encodelocalstorage";
function escapeRegExp(txt) {
  if (!_.isString(txt)) {
    return "";
  }
  return txt.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

export function searchTopicdetail(search) {
  const searchtext = escapeRegExp(search);
  const majordata = getdataAndDecodeStoreData("dataMajor");
  const minordata = getdataAndDecodeStoreData("dataMinor");
  const investdata = getdataAndDecodeStoreData("dataInvest");
  const laserdata = getdataAndDecodeStoreData("dataLaser");
  const AdataPhaco = getdataAndDecodeStoreData("phaco");

  let resultURL = "";
  let resultsearch = "";
  let objectresult = {};
  if (!searchtext) return;
  if (searchtext !== " ") {
    majordata.map((ele) => {
      if (ele.topic.toLowerCase().match(searchtext.toLowerCase())) {
        resultURL = `/logbook/major operation/${ele.topic}`;
        resultsearch = ele.topic;
      }
      if (localStorage.getItem(ele.topic.toLowerCase())) {
        let localData = getdataAndDecodeStoreData(ele.topic.toLowerCase());

        localData.map((data) => {
          if (data.hn.toLowerCase() === searchtext.toLowerCase()) {
            resultURL = `/logbook/major operation/${ele.topic}`;
            resultsearch = `${ele.topic}`;
          }
        });
      }
    });
    minordata.map((ele) => {
      console.log("ค้นหา แสดงข้อมูล minordata >>>", ele.topic.toLowerCase());
      if (ele.topic.toLowerCase().match(searchtext.toLowerCase())) {
        resultURL = `/logbook/minor operation/${ele.topic}`;
        resultsearch = ele.topic;
      }
      if (localStorage.getItem(ele.topic.toLowerCase())) {
        let localData = getdataAndDecodeStoreData(ele.topic.toLowerCase());

        localData.map((data) => {
          if (data.hn.toLowerCase() === searchtext.toLowerCase()) {
            resultURL = `/logbook/minor operation/${ele.topic}`;
            resultsearch = `${ele.topic}`;
          }
        });
      }
    });
    investdata.map((ele) => {
      if (ele.topic.toLowerCase().match(searchtext.toLowerCase())) {
        resultURL = `/logbook/investigation/${ele.topic}`;
        resultsearch = ele.topic;
      }
      if (localStorage.getItem(ele.topic.toLowerCase())) {
        let localdata = getdataAndDecodeStoreData(ele.topic.toLowerCase());

        localdata.map((data) => {
          if (data.hn.toLowerCase() === searchtext.toLowerCase) {
            resultURL = `/logbook/investigation/${ele.topic}`;
            resultsearch = `${ele.topic}`;
          }
        });
      }
    });
    laserdata.map((ele) => {
      if (ele.topic.toLowerCase().match(searchtext.toLowerCase())) {
        resultURL = `/logbook/laser procedure/${ele.topic}`;
        resultsearch = ele.topic;
      }
      if (localStorage.getItem(ele.topic.toLowerCase())) {
        let localData = getdataAndDecodeStoreData(ele.topic.toLowerCase());

        localData.map((data) => {
          if (data.hn.toLowerCase() === searchtext.toLocaleLowerCase()) {
            resultURL = `/logbook/laser procedure/${ele.topic}`;
            resultsearch = ele.topic;
          }
        });
      }
    });
  }
  objectresult = { search: resultsearch, url: resultURL };
  return objectresult;
}

export function searchlistLogbookdetail(search, data) {
  const textsearch = escapeRegExp(search);
  const datasearch = [];
  console.log(data);
  if (!data) return;
  data.map((ele) => {
    if (ele.hn.toLowerCase().trim().match(textsearch)) {
      datasearch.push(ele);
    } else if (ele.date.toLowerCase().trim().match(textsearch)) {
      datasearch.push(ele);
    } else if (ele.supervisor.toLowerCase().trim().match(textsearch)) {
      datasearch.push(ele);
    } else if (ele.file.toLowerCase().trim().match(textsearch)) {
      datasearch.push(ele);
    } else if (ele.link.toLowerCase().trim().match(textsearch)) {
      datasearch.push(ele);
    }
  });
  console.log("this a data search =>", datasearch);
  return datasearch;
}
